import { useQuery } from '@tanstack/react-query';
import { getPronos } from './api'; // Importation de la fonction asynchrone
import { Prono } from './type';
import { AxiosError } from 'axios';

const useGetPronos = (date: string, reunion: number, course: number) => {
  return useQuery<Prono[], AxiosError>({
    queryKey: ['pronos', `${date}-${reunion}-${course}`],
    queryFn: () => getPronos(date, reunion, course),
    enabled: !!date && date.length > 0,
    staleTime: 1000 * 60 * 1,
    retry: (failureCount, error) => error.response?.status !== 404,
    refetchOnWindowFocus: false,
  });
};

export default useGetPronos;
